if (!KMVP) {
    var KMVP = {};
}
if (!KMVP.updatetermsandconditions) {
	KMVP.updatetermsandconditions = {};
}

KMVP.updatetermsandconditions.doPopup = function () {
    if (typeof displayUpdateTermsAndConditionsPopup !== 'undefined' && displayUpdateTermsAndConditionsPopup !== null && displayUpdateTermsAndConditionsPopup) {
        $.ajax({
            url: KMVP.updatetermsandconditions.popupUrl,
            success: function (data) {
                $.colorbox({
                innerWidth: "560px",
                html: $(data).find('#updateTermsAndConditionsPopupContainer'),
                scrolling: false,
                escKey: false,
                overlayClose: false,
                    height: false,
                onLoad: function() {
                        $('#cboxClose').remove();
                    },
                onComplete: function (){
                        $(this).colorbox.resize({innerWidth:"953px", innerHeight:"559px"});
                    }
                });
            }
        });
    }
};

KMVP.updatetermsandconditions.acceptTermsAndConditions = function () {
    var confirmationUrl = $('#updateTermsAndConditionsButtonPos').data("href");
    $.ajax({
        url: confirmationUrl,
        success: function () {
            $.colorbox.close();
        }
    });
};

KMVP.updatetermsandconditions.readLaterTermsAndConditions = function () {
    var readLaterUrl = $('#readLaterTermsAndConditionsButton').data("href");
    $.ajax({
        url: readLaterUrl,
        success: function () {
            $.colorbox.close();
        }
    });
};

$(document).ready(function() {
    KMVP.updatetermsandconditions.doPopup();
});
